.header {
    padding: 15px;
    background: var(--hps-white);
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.headerContent {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
